import React from 'react';
import './skeleton.css';

const Skeleton = ({
  type = 'line',
  rows = 5,
  cols = 5,
  lines = 3,
  text = '',
  className = '',
  prefix = 'skeleton',
}) => {
  if (type === 'table') {
    return (
      <tbody className={className}>
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <tr key={`${prefix}-row-${rowIndex}`}>
            {Array.from({ length: cols }).map((__, colIndex) => (
              <td key={`${prefix}-cell-${rowIndex}-${colIndex}`}>
                <div className="skeleton-line" />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    );
  }

  if (type === 'stack') {
    return (
      <div className={`skeleton-stack ${className}`.trim()}>
        {text ? <div className="skeleton-text">{text}</div> : null}
        {Array.from({ length: lines }).map((_, index) => (
          <div key={`${prefix}-line-${index}`} className="skeleton-line" />
        ))}
      </div>
    );
  }

  return <div className={`skeleton-line ${className}`.trim()} />;
};

export default Skeleton;
